import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BillingManagementService } from 'src/service/billing-management.service';
import { FocusInputType, KeyValueId, KeyValueIdGroup, KeyValues3, LocalService } from 'src/service/local.service';

@Component({
  selector: 'app-overwrite-discount',
  templateUrl: './overwrite-discount.component.html',
  styleUrl: './overwrite-discount.component.scss'
})
export class OverwriteDiscountComponent {
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onCompleted = new EventEmitter();

  @Input() businessId: string = ''; @Input() billingDetailId: string = '';
  @Input() baseAmount: number = null; @Input() taxDetails: KeyValueId[];

  selectedRadioOption = 1; sourceCurrentDiscountPercentage: number = null; discountPercentage: number = null; discountAmount: number = null;

  htmlId: string = ''; elementIds: any;
  constructor(public localService: LocalService, private billingManagementService: BillingManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      btn_currentPrice: 'currentPrice_' + this.htmlId,
      btn_totalPrice: 'totalPrice_' + this.htmlId,
    };
  }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
    }
  }

  onLoad() {
    if (!this.taxDetails) {
      this.taxDetails = [];
    }
    this.selectedRadioOption = 1;
    setTimeout(() => {
      this.onSetFocus();
      this.onExtractDiscount();
      this.sourceCurrentDiscountPercentage = this.discountPercentage;
    }, 100);
  }

  onSetFocus() {
    this.localService.onFocusNextInput(this.selectedRadioOption == 1 ? this.elementIds.btn_currentPrice : this.elementIds.btn_totalPrice, FocusInputType.TextBox);
  }

  onBeforeDismiss(): boolean {
    this.taxDetails = [];
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onClosePopup() {
    this.onBeforeDismiss();
  }

  onAction(index: number) {
    switch (index) {
      case 1: {
        this.onClosePopup();
      } break;
      case 2: {
        this.onChecked(1);
      } break;
      case 3: {
        this.onChecked(2);
      } break;
      case 4: {
        this.onUpdatePrice();
      } break;
    }
  }

  onChecked(value) {
    this.selectedRadioOption = value;
    this.onSetFocus();
  }

  onUpdatePrice() {
    if (this.sourceCurrentDiscountPercentage != this.discountPercentage) {
      this.billingManagementService.saveDiscountForBilledProduct(this.billingDetailId, this.discountPercentage).subscribe(result => {
        this.onSetDiscount();
        this.onCompleted.emit(this.taxDetails);
        this.onClosePopup();
      });
    } else {
      this.onClosePopup();
    }
  }

  onCalculate(isPercentage: boolean) {
    if (isPercentage) {
      if (this.discountPercentage) {
        this.discountAmount = parseFloat((((this.baseAmount ?? 0) * (this.discountPercentage ?? 0)) / 100).toFixed(2));
      } else {
        this.discountAmount = null;
      }
    } else {
      if (this.discountAmount) {
        this.discountPercentage = parseFloat((((this.discountAmount ?? 0) / (this.baseAmount ?? 0)) * 100).toFixed(2));
      } else {
        this.discountPercentage = null;
      }
    }
  }

  onExtractDiscount() {
    this.discountPercentage = null;
    const discountDetail = this.taxDetails.find(x => x.key == 'discount');
    if (discountDetail) {
      this.discountPercentage = parseFloat(discountDetail.value?.toString() ?? '0');
    }
    this.onCalculate(true);
  }

  onSetDiscount() {
    if (this.discountPercentage || this.discountPercentage == 0) {
      let discountDetail = this.taxDetails.find(x => x.key == 'discount');
      if (discountDetail) {
        discountDetail.value = this.discountPercentage.toString();
      } else {
        this.taxDetails.push({
          key: 'discount',
          value: this.discountPercentage.toString()
        } as KeyValueId);
      }
    } else {
      this.taxDetails = this.taxDetails.filter(x => x.key != 'discount');
    }
  }
}
